<div class="actions-container" *ngIf="item.entityType==='DOCUMENT'">
    <button tam-button tamType="primary" tamSize="small" class="btn" (click)="submit()" [disabled]="item.isSubmitted"
        [tamLoading]="isSaving">Submit</button>
    <button tam-button tamType="primary" tamSize="small" class="btn" (click)="quickSubmit()"
        [disabled]="item.isSubmitted ||missMapping" [tamLoading]="isSaving">Quick Submit</button>
</div>